import type { FleetBaseParameters } from '../interfaces/fleet';

export const FLEET_BASE_PARAMETERS_KEYS = [
  'isLowDeck',
  'semiTrailerSize',
  'trailerSize',
  'coilWellLength',
] as const satisfies (keyof FleetBaseParameters)[];
